//  [REDUCER][TYPE]
import { typeCreatorV2 } from '../../utils/common';

export const SET_MODAL_VISIBILITY: string = typeCreatorV2(
  'ModalReducer',
  'SetModalVisibility'
);

export enum ModalIDs {
  TOAST = 1,
  MODAL_DASHBOARD_ADD_GRAPH = 2,
  MODAL_FIXED_ESTABLISHMENT = 3,
  MODAL_IDENTIFICATION_IN_OTHER_EU_COUNTRIES = 4,
  MODAL_PREVIOUS_USE_OF_SPECIAL_SCHEMES = 5,
  MODAL_DASHBOARD_ELEMENT_CONFIG = 6, // dashboardbuilder_page
  MODAL_DASHBOARD_ELEMENT_REMOVE = 7, // dashboardbuilder_page
  MODAL_DASHBOARD_BUILDER_SETTINGS = 8, // dashboardbuilder_page
  MODAL_DASHBOARD_SAVE = 12, // dashboardbuilder_page
  MODAL_CONFIG_WRAPPER = 10,
  MODAL_FORM_WRAPPER = 11, // forms_page
  // FOR GENERATOR
  MODAL_ADD_EDIT_USER = 9,
  MODAL_EDIT_PRODUCT_IMAGE = 14,
  MODAL_EDIT_CLIENT_IMAGE = 19,
  MODAL_EDIT_PRODUCT_FLOORPLAN = 15,
  MODAL_EDIT_PRODUCT_DOCUMENT = 16,
  MODAL_ADD_NOTE = 17,
  MODAL_EDIT_CLIENT_DOCUMENT = 18,

  // ecomm
  MODAL_ADD_EDIT_PRODUCT = 'MODAL_ADD_EDIT_PRODUCT',
  MODAL_ADD_EDIT_CLIENT = 'MODAL_ADD_EDIT_CLIENT',
  MODAL_OPTIONS = 'MODAL_OPTIONS',
  PRODUCT_FILTER_MODAL = 'PRODUCT_FILTER_MODAL',
  ADD_PRODUCT_MODAL = 'ADD_PRODUCT_MODAL',
  MODAL_ADD_EDIT_CATEGORY = 'MODAL_ADD_EDIT_CATEGORY',
  MODAL_ADD_EDIT_TOPIC = 'MODAL_ADD_EDIT_TOPIC',
  MODAL_PRINT = 'MODAL_PRINT',
  MODAL_ADD_MY_PROPERTY_COLLECTION = 'MODAL_ADD_MY_PROPERTY_COLLECTION',
  MODAL_ASSIGN_CLIENT = 'MODAL_ASSIGN_CLIENT',
  MODAL_ADD_CLIENT_REQUEST = 'MODAL_ADD_CLIENT_REQUEST',
  MODAL_CLONE_PROPERTY = 'MODAL_CLONE_PROPERTY',
  MODAL_ADD_COLLECTION = 'MODAL_ADD_COLLECTION',
  MODAL_SEND_MAIL = 'MODAL_SEND_MAIL',
  MODAL_ASSIGN_SUCCESS = 'MODAL_ASSIGN_SUCCESS',
  MODAL_ADD_COLLECTION_SUCCESS = 'MODAL_ADD_COLLECTION_SUCCESS',
  MODAL_SHARE = 'MODAL_SHARE',
  MODAL_SHARE_APPOINTMENT_AND_TASKS = 'MODAL_SHARE_APPOINTMENT_AND_TASKS',
  MODAL_ADD_EDIT_BLOG = 'MODAL_ADD_EDIT_BLOG',
  MODAL_ADD_EDIT_STORES = 'MODAL_ADD_EDIT_STORES',
  MODAL_ICON_PICKER = 'MODAL_ICON_PICKER',
  MODAL_ADD_EDIT_SPECIFICATIONATTRIBUTE = 'MODAL_ADD_EDIT_SPECIFICATIONATTRIBUTE',
  MODAL_ADD_EDIT_NEWS = 'MODAL_ADD_EDIT_NEWS',
  MODAL_EDIT_PRODUCT_TAG = 'MODAL_EDIT_PRODUCT_TAG',
  MODAL_EDIT_CUSTOMER_TAG = 'MODAL_EDIT_CUSTOMER_TAG',

  MODAL_ADD_NEW_POI = 'MODAL_ADD_NEW_POI',
  MODAL_ADD_NEW_POI_CATEGORY = 'MODAL_ADD_NEW_POI_CATEGORY',
  MODAL_ADD_EDIT_NEWSLETTERSUBSCRIPTION = 'MODAL_ADD_EDIT_NEWSLETTERSUBSCRIPTION',
  MODAL_ADD_EDIT_TASK = 'MODAL_ADD_EDIT_TASK',
  MODAL_ADD_DOCUMENT = 'MODAL_ADD_DOCUMENT',
  MODAL_ADD_SAVE_SEARCH = 'MODAL_ADD_SAVE_SEARCH',
  MODAL_DOCUMEMT_ADD_SECTION = 'MODAL_DOCUMEMT_ADD_SECTION',
  MODAL_ADD_DOCUMENT_PROPERTY = 'MODAL_ADD_DOCUMENT_PROPERTY',
  MODAL_ADD_DOCUMENT_DROPDOWN = 'MODAL_ADD_DOCUMENT_DROPDOWN',
  MODAL_DETAIL_DOCUMENT_PROPERTY = 'MODAL_DETAIL_DOCUMENT_PROPERTY',
  MODAL_ADD_SAVE_SEARCH_PROPERTY = 'MODAL_ADD_SAVE_SEARCH_PROPERTY',
  MODAL_ADD_NEW_EVENT = 'MODAL_ADD_NEW_EVENT',
  MODAL_DOCUMEMT_MANAGE_CUSTOMERS = 'MODAL_DOCUMEMT_MANAGE_CUSTOMERS',
}
